import WS from '../ws'
import { decodeAggreDeals, decodeKline } from '../protobufUtils'
/* eslint-disable */
export default class Api {
  constructor(timeout = 5e3, maxAttempts = 5) {
    this.timeout = timeout
    this.maxAttempts = maxAttempts

    const protocol = (typeof window !== 'undefined' && window.location.protocol === 'https:') ? 'wss:' : 'ws:'
    this._baseUrl = `${protocol}//wbs-api.mexc.com/ws`
    this.subscription = {}
    this.subscriptionId = 1
    this.pingInterval = null
    this.streamCallbacks = {} // Armazenar múltiplos callbacks por stream
    this.streams = {

      depth: (symbol) => `spot@public.limit.depth.v3.api.pb@${symbol.toUpperCase()}`,
      kline: (symbol, interval) => `spot@public.kline.v3.api.pb@${symbol.toUpperCase()}@${interval}`,
      
      // K-line stream para dados de 24h - PRINCIPAL PARA VOLUME E VARIAÇÃO
      // Formato oficial da documentação: spot@public.kline.v3.api.pb@<symbol>@<interval>
      kline24h: (symbol) => `spot@public.kline.v3.api.pb@${symbol.toUpperCase()}@Day1`,
      
      trade: (symbol) => `spot@public.deals.v3.api.pb@${symbol.toUpperCase()}`,
      
      // Aggregated Deals Stream - NEGOCIAÇÕES AGREGADAS EM TEMPO REAL
      aggDeals: (symbol) => `spot@public.aggre.deals.v3.api.pb@100ms@${symbol.toUpperCase()}`,
      
      // Individual Symbol Book Ticker Streams - PARA PREÇO EM TEMPO REAL
      ticker: (symbol) => `spot@public.bookTicker.v3.api.pb@${symbol.toUpperCase()}`,
      
      // Individual Symbol Book Ticker Streams (Batch Aggregation) - RECOMENDADO
      aggTicker: (symbol) => `spot@public.aggre.bookTicker.v3.api.pb@100ms@${symbol.toUpperCase()}`,
    
    };
  }

  subscribe(cb, stream) {
    let ws;
    
    // Adicionar callback ao stream
    if (!this.streamCallbacks[stream]) {
      this.streamCallbacks[stream] = [];
    }
    this.streamCallbacks[stream].push(cb);
    
    try {
      if (this.subscription[this._baseUrl]) {
        // Usar conexão existente
        ws = this.subscription[this._baseUrl];
        
        // Sempre enviar inscrição para garantir que o stream esteja ativo
        this.sendSubscription(stream, 'SUBSCRIPTION');
        
        return ws;
      }

      ws = new WS(this._baseUrl, {
        timeout: this.timeout,
        maxAttempts: this.maxAttempts,
        onopen: e => {
          // Connected to MEXC WebSocket
          console.log(`🔗 [MEXC WebSocket] Nova conexão estabelecida: ${this._baseUrl}`)
          console.log(`📊 [MEXC WebSocket] Timestamp: ${new Date().toISOString()}`)
          this.startPing(ws);
          this.sendSubscription(stream, 'SUBSCRIPTION');
        },
        onmessage: e => {
          // Verificar se é uma mensagem de controle JSON
          if (typeof e.data === 'string') {
            try {
              const data = JSON.parse(e.data);
              if (data.msg === 'PONG' || data.method === 'SUBSCRIPTION') {
                // Control message received
                return;
              }
              
              // Identificar o stream baseado nos dados recebidos
              const targetStream = this.identifyStreamFromData(data);
              if (targetStream) {
                this.executeStreamCallbacks(targetStream, data);
              }
              return;
            } catch (jsonError) {
              // Error processing JSON message
              return;
            }
          }
          
          // Se é um Blob, pode ser dados protobuf (.pb) ou JSON
          if (e.data instanceof Blob) {
            e.data.arrayBuffer().then(buffer => {
              try {
                // Para streams .pb, usar decodificador protobuf apropriado
                if (stream && stream.includes('.pb@')) {
                  // Processing protobuf data usando abordagem híbrida
                  let decodedData = null;
                  
                  // Determinar qual decoder usar baseado no tipo de stream
                  if (stream.includes('kline')) {
                    decodedData = decodeKline(buffer);
                  } else if (stream.includes('deals')) {
                    decodedData = decodeAggreDeals(buffer);
                  }
                  
                  if (decodedData) {
                    const targetStream = this.identifyStreamFromData(decodedData);
                    if (targetStream) {
                      this.executeStreamCallbacks(targetStream, decodedData);
                    }
                    return;
                  }
                } else {
                  // Stream normal, processar como JSON
                  const text = new TextDecoder().decode(buffer);
                  const data = JSON.parse(text);
                  const targetStream = this.identifyStreamFromData(data);
                  if (targetStream) {
                    this.executeStreamCallbacks(targetStream, data);
                  }
                }
              } catch (error) {
                // Error processing Blob
              }
            }).catch(error => {
              // Error processing Blob buffer
            });
            return;
          }
          
          // Se é ArrayBuffer, pode ser dados protobuf (.pb)
          if (e.data instanceof ArrayBuffer) {
            try {
              if (stream && stream.includes('.pb@')) {
                // Para streams .pb, usar decodificador protobuf apropriado                
                let decodedData = null;
                
                // Determinar qual decoder usar baseado no tipo de stream
                if (stream.includes('kline')) {
                  decodedData = decodeKline(e.data);
                } else if (stream.includes('deals')) {
                  decodedData = decodeAggreDeals(e.data);
                }
                
                                  if (decodedData) {
                    const targetStream = this.identifyStreamFromData(decodedData);
                    if (targetStream) {
                      this.executeStreamCallbacks(targetStream, decodedData);
                    }
                    return;
                  }
                  
                  // Fallback para texto
                  const text = new TextDecoder().decode(e.data);
                  try {
                    const data = JSON.parse(text);
                    const targetStream = this.identifyStreamFromData(data);
                    if (targetStream) {
                      this.executeStreamCallbacks(targetStream, data);
                    }
                  } catch (jsonError) {
                    // ArrayBuffer protobuf data is not valid JSON
                    // Enviar dados brutos
                    const targetStream = this.identifyStreamFromData({ 
                      protobuf: true,
                      rawData: e.data, 
                      stream, 
                      timestamp: Date.now(),
                      textPreview: text.substring(0, 100)
                    });
                    if (targetStream) {
                      this.executeStreamCallbacks(targetStream, { 
                        protobuf: true,
                        rawData: e.data, 
                        stream, 
                        timestamp: Date.now(),
                        textPreview: text.substring(0, 100)
                      });
                    }
                  }
              } else {
                // Stream normal
                const text = new TextDecoder().decode(e.data);
                const data = JSON.parse(text);
                const targetStream = this.identifyStreamFromData(data);
                if (targetStream) {
                  this.executeStreamCallbacks(targetStream, data);
                }
              }
            } catch (error) {
              // Error processing ArrayBuffer
            }
            return;
          }
          
          // Unsupported message type
        },
        onreconnect: e => {
          // Reinscrever em todos os streams ativos
          if (ws.activeStreams) {
            ws.activeStreams.forEach(activeStream => {
              this.sendSubscription(activeStream, 'SUBSCRIPTION');
            });
          }
        },
        onmaximum: e => { /* Maximum attempts reached */ },
        onclose: e => { 
          this.stopPing();
          this.removeSubscription(e.endpoint);
        },
        onerror: e => { /* WebSocket error */ }
      });

      this.subscription[this._baseUrl] = ws;
      this.subscription[this._baseUrl].activeStreams = this.subscription[this._baseUrl].activeStreams || new Set();
      
    } catch(ex) {
      // Connection error
    }
    return ws;
  }

  sendSubscription(stream, method) {
    const ws = this.subscription[this._baseUrl];
    if (ws && ws.send) {
      const message = {
        method: method,
        params: [stream]
      };
      ws.send(message);
      
      if (method === 'SUBSCRIPTION') {
        ws.activeStreams.add(stream);
      } else if (method === 'UNSUBSCRIPTION') {
        ws.activeStreams.delete(stream);
      }
    }
  }

  startPing(ws) {
    this.pingInterval = setInterval(() => {
      if (ws && ws.send) {
        ws.send({ method: 'PING' });
      }
    }, 30000); // Ping a cada 30 segundos
  }

  stopPing() {
    if (this.pingInterval) {
      clearInterval(this.pingInterval);
      this.pingInterval = null;
    }
  }

  caller(fname, ...args) {
    return this.streams[fname].call(null, ...args)
  }

  removeSubscription(endpoint) {
    if(this.subscription[endpoint]) {
      this.stopPing();
      delete this.subscription[endpoint];
    }
  }

  identifyStreamFromData(data) {
    // Tentar identificar o stream baseado nos dados recebidos
    if (data && typeof data === 'object') {
      // Para dados de kline
      if (data.kline || data.publicSpotKline) {
        const symbol = data.symbol || data.kline?.symbol;
        if (symbol) {
          // Procurar por um stream que contenha este símbolo
          for (const stream in this.streamCallbacks) {
            if (stream.includes(symbol.toUpperCase())) {
              return stream;
            }
          }
        }
      }
      
      // Para dados de deals
      if (data.deals || data.publicAggreDeals) {
        const symbol = data.symbol || data.deals?.symbol;
        if (symbol) {
          for (const stream in this.streamCallbacks) {
            if (stream.includes(symbol.toUpperCase())) {
              return stream;
            }
          }
        }
      }
      
      // Para dados de ticker
      if (data.symbol && (data.price || data.volume)) {
        for (const stream in this.streamCallbacks) {
          if (stream.includes(data.symbol.toUpperCase())) {
            return stream;
          }
        }
      }
    }
    
    // Se não conseguir identificar, retornar o primeiro stream disponível
    const availableStreams = Object.keys(this.streamCallbacks);
    return availableStreams.length > 0 ? availableStreams[0] : null;
  }

  executeStreamCallbacks(stream, data) {
    if (this.streamCallbacks[stream]) {
      this.streamCallbacks[stream].forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error('Erro ao executar callback do stream:', error);
        }
      });
    }
  }

  closeSubscription(type, ...args) {
    const stream = this.caller(type, ...args);
    
    // Remover todos os callbacks deste stream
    if (this.streamCallbacks[stream]) {
      delete this.streamCallbacks[stream];
    }
    
    this.sendSubscription(stream, 'UNSUBSCRIPTION');
  }

  closeAll() {
    const ws = this.subscription[this._baseUrl];
    if (ws && ws.activeStreams) {
      ws.activeStreams.forEach(stream => {
        this.sendSubscription(stream, 'UNSUBSCRIPTION');
      });
    }
    
    for (const key in this.subscription) {
      this.subscription[key].close();
      delete this.subscription[key];
    }
    this.stopPing();
    this.subscription = {};
    this.streamCallbacks = {}; // Limpar todos os callbacks
  }

  onDepthUpdate(symbol, eventHandler) {
    return this.subscribe(eventHandler, this.streams.depth(symbol));
  }

  onKline(symbol, interval, eventHandler) {
    const stream = this.streams.kline(symbol, interval);
    return this.subscribe(eventHandler, stream);
  }

  onTrade(symbol, eventHandler) {
    return this.subscribe(eventHandler, this.streams.trade(symbol));
  }

  onAggTicker(symbol, eventHandler) {
    return this.subscribe(eventHandler, this.streams.aggTicker(symbol));
  }

  onAggDeals(symbol, eventHandler) {
    return this.subscribe(eventHandler, this.streams.aggDeals(symbol));
  }

  onKline24h(symbol, eventHandler) {
    return this.subscribe(eventHandler, this.streams.kline24h(symbol));
  }

}
